<template>
    <div v-show="aiChatShow" class="chat-wrapper">
        <div class="chat-logo" @click="openChatDrawer()" ref="chatLogoRef">
            <el-tooltip effect="dark" :hide-after="2000" placement="left-start">
                <div slot="content">Hi! {{ $route.name === 'classManagementDetail' ? '老师' : '求学者' }}<br />我是AI助手，有问题可以联系我
                </div>
                <img src="../../assets/img/chat/ai.png" alt="">
            </el-tooltip>
        </div>
        <el-drawer title="智能助手" :visible.sync="aiChatDrawerShow" :size="800" custom-class="custom-drawer"
            :wrapperClosable="false">
            <iframe class="ai-chat-iframe" :src="`${v3Url}/#/aiChat`" scrolling="no" frameborder="0"
                ref="iframeRef"></iframe>
        </el-drawer>
    </div>
</template>

<script>
import { postAjax } from '@/api';
import Drag from '@/utils/drag.js';
export default {
    data() {
        return {
            aiChatDrawerShow: false,
            v3Url: '',
            drag: null
        }
    },
    computed: {
        aiChatShow() {
            const { name } = this.$route;
            const showAichatCompList = ['home', 'moreList', 'courseDetail', 'classDetail', 'coursePaper', 'courseTask', 'courseVideo', 'courseHandouts', 'evaluationReport', 'answerDetail', 'classManagementDetail'];
            return false;
            return showAichatCompList.includes(name);
        }
    },
    methods: {
        getV3Url() {
            postAjax('/home/v3Url').then(res => {
                if (res.code === 1) {
                    this.v3Url = res.data;
                }
            });
        },
        postMessageToIframe(action) {
            const iframe = this.$refs.iframeRef;
            if (!iframe) return;
            switch (action) {
                case 'getAiChatData':
                    const { meta, params } = this.$route;
                    const iframeData = {
                        page_type: meta.aiChatPageType,
                        spaceid: params.spaceid || '',
                        subid: params.subid || '',
                        sccid: params.sccid || '',
                    }
                    iframe.contentWindow.postMessage({
                        action,
                        payload: iframeData
                    }, '*');
                    break;
                case 'experimentalScreenshot':
                    try {
                        const displayDiv = document.getElementById('display');
                        const canvases = displayDiv.getElementsByTagName('canvas');
                        const canvas = canvases[canvases.length - 1];
                        const base64 = canvas.toDataURL('image/png');
                        iframe.contentWindow.postMessage({
                            action,
                            payload: base64
                        }, '*');
                    } catch (e) {
                        iframe.contentWindow.postMessage({
                            action,
                            payload: null
                        }, '*');
                    }
                    break;
                case 'isShowExperimentalScreenshot':
                    iframe.contentWindow.postMessage({
                        action,
                        payload: this.$route.name === 'courseTask'
                    }, '*');
                    break;
                case 'newSession':
                    iframe.contentWindow.postMessage({
                        action,
                        payload: null
                    }, '*');
                    break;
            }
        },
        onMessageHandler(event) {
            switch (event.data.action) {
                case 'getAiChatData':
                    this.postMessageToIframe('getAiChatData');
                    break;
                case 'experimentalScreenshot':
                    this.postMessageToIframe('experimentalScreenshot');
                    break;
                case 'isShowExperimentalScreenshot':
                    this.postMessageToIframe('isShowExperimentalScreenshot');
                    break;
            }
        },
        openChatDrawer() {
            const token = localStorage.getItem('utoken');
            if (!token) {
                this.$router.push('/login');
                return;
            }
            // 如果不处于拖拽状态才能点击
            if (!this.drag.isDragging) {
                this.aiChatDrawerShow = true;
                this.postMessageToIframe('getAiChatData');
                this.postMessageToIframe('isShowExperimentalScreenshot');
            }
        },
        onPopstateHandler() {
            this.aiChatDrawerShow = false;
        }
    },
    watch: {
        aiChatShow: {
            handler(newVal) {
                if (this.drag || !newVal) return;
                this.$nextTick(() => {
                    this.drag = new Drag(this.$refs.chatLogoRef, {
                        leftEdgeSuctionStyle: {
                            transform: 'translateX(calc(0px - var(--size24))) rotate(45deg)',
                        },
                        rightEdgeSuctionStyle: {
                            transform: 'translateX(var(--size24)) rotate(-45deg)',
                        },
                        hoverStyle: {
                            transform: 'translateX(0px) rotate(0deg)',
                        }
                    });
                });
            },
            immediate: true
        },
        $route() {
            this.postMessageToIframe('newSession');
        }
    },
    created() {
        this.getV3Url();
        window.addEventListener('message', this.onMessageHandler);
        window.addEventListener('popstate', this.onPopstateHandler)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.onMessageHandler);
        window.removeEventListener('popstate', this.onPopstateHandler);
        this.drag && this.drag.cancel();
        this.drag = null;
    }
}
</script>

<style scoped lang="scss">
.chat-wrapper {
    width: 0;
    height: 0;
    overflow: hidden;

    .chat-logo {
        position: fixed;
        top: 80%;
        right: 0;
        z-index: 10;
        width: var(--size60);
        height: var(--size60);
        cursor: pointer;
        transition: transform 0.3s;

        img {
            display: block;
            width: 100%;
            user-select: none;
            -webkit-user-drag: none;
        }
    }
}

.ai-chat-iframe {
    height: 99.5%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AIChatComp/AiChatComp.vue